module.exports = __webpack_public_path__ + "static/media/invisibleDownload.2b6bfad5.svg";